import React from "react";
import { Price } from "../types/price";
import { stringIsPresent } from "../utils/checks";
import styles from "./PricesFromWithChip.module.scss";
import { PriceItem, PriceItemProps } from "../Prices/PriceItem/PriceItem";
import clsx from "clsx";

export type PricesFromWithChipProps = Partial<
  Omit<PriceItemProps, "price" | "priceType" | "showFareLabel">
> & {
  prices?: Price[];
  pricesDisclaimer?: string;
  pricesDisclaimerClassName?: string;
  wrapperClassName?: string;
  itemClassName?: string;
  align?: "responsive" | "force-center" | "force-right";
};

export const PricesFromWithChip: React.FC<
  React.PropsWithChildren<PricesFromWithChipProps>
> = ({
  prices = [],
  pricesDisclaimer,
  pricesDisclaimerClassName,
  wrapperClassName,
  itemClassName,
  layout = "row-compact",
  variant = "big",
  align,
  ...props
}) => {
  const isWaitlist = prices?.every((p) => p.type == "waitlist");
  const filteredPrices = isWaitlist
    ? [prices[0]]
    : prices.filter((p) => p.type !== "waitlist");

  return (
    <div
      className={clsx(
        styles.wrapper,
        { [styles.forceCenter]: align == "force-center" },
        { [styles.forceRight]: align == "force-right" },
        wrapperClassName
      )}
    >
      {filteredPrices.map((p) => (
        <PriceItem
          key={p.fareLabel}
          layout={layout}
          chipBackgroundColor="neutral05"
          price={p}
          priceType="primary"
          showFareLabel
          variant={variant}
          className={clsx(styles.price, itemClassName)}
          priceClassName={styles.priceItem}
          {...props}
        />
      ))}

      {!isWaitlist && stringIsPresent(pricesDisclaimer) && (
        <div
          className={clsx(styles.pricesDisclaimer, pricesDisclaimerClassName)}
        >
          {pricesDisclaimer}
        </div>
      )}
    </div>
  );
};
